import type { SxProps } from "@mui/material";
import type { Theme } from "@mui/material/styles";

/**
 * Estilo padrão de borda para todos os Cards da tela de novo pedido.
 * Usar junto com variant="outlined" no componente Card.
 */
export const cardOutlinedSx: SxProps<Theme> = {
  borderRadius: 2,
  borderColor: "divider",
  overflow: "hidden",
};

export const labelSx = {
  "& .MuiInputLabel-root": { color: "common.black", fontSize: "1.5rem" },
  "& .MuiInputLabel-shrink": {
    fontWeight: "bold",
    fontSize: "1.8rem",
    backgroundColor: "background.paper",
    px: "4px",
  },
};

const disabledBaseSx = {
  "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(0, 0, 0, 0.23)",
  },
  "& .MuiInputLabel-root": {
    color: "common.black",
    fontSize: "1.5rem",
  },
  "& .MuiInputLabel-shrink": {
    fontWeight: "bold",
    fontSize: "1.8rem",
  },
  "& .MuiOutlinedInput-notchedOutline legend": {
    fontSize: "1.05em",
  },
};

/**
 * Estilo para TextField disabled (inputs de texto simples).
 * Força a cor do texto (WebkitTextFillColor) para manter legibilidade
 * e aplica background cinza no input.
 */
export const disabledFieldSx = (theme: Theme) => ({
  ...disabledBaseSx,
  "& .MuiOutlinedInput-root.Mui-disabled": {
    backgroundColor: theme.palette.grey[100],
  },
  "& .MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: theme.palette.common.black,
  },
  "& .MuiInputLabel-root": {
    ...disabledBaseSx["& .MuiInputLabel-root"],
    "&.Mui-disabled": {
      color: "common.black",
    },
  },
});

/**
 * Estilo para Select disabled (dropdowns).
 * Não força WebkitTextFillColor (o Select já exibe o texto corretamente),
 * mas adiciona background e padding no label shrink para evitar que a
 * borda do outlined corte o texto do label.
 */
export const disabledSelectSx = (theme: Theme) => ({
  ...disabledBaseSx,
  "& .MuiOutlinedInput-root.Mui-disabled": {
    backgroundColor: theme.palette.grey[100],
  },
  "& .MuiInputLabel-shrink": {
    ...disabledBaseSx["& .MuiInputLabel-shrink"],
    backgroundColor: "background.paper",
    px: "4px",
  },
});

/**
 * Estilo para o CalendarSpecific quando desabilitado.
 * Aplica background cinza no input outlined.
 */
export const disabledCalendarSx = (theme: Theme) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: theme.palette.grey[100],
  },
});
